import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { ServiciosWebServiceProvider } from '../web-service-service/servicios-web-service';
import { Informe } from '../../domain/Informe';
import { Contenido } from '../../domain/Contenido';
import { EntityManagerProvider } from '../entity-manager-provider/entity-manager-provider';
import { IdiomaService } from '../idioma/idioma.service';
import { ServiciosStatsProvider } from '../web-service-service/servicios-stats';
import { HistoricoLocalizacionContenido } from '../../domain/HistoricoLocalizacionContenido';
import { forEach } from '@angular/router/src/utils/collection';
import { CoincidenciasLocalizacionContenidos } from '../../domain/CoincidenciasLocalizacionContenidos';
import { TranslateService } from '../../../../node_modules/ng2-translate';
import { DatePipe } from '../../../../node_modules/@angular/common';
import { SeccionPlano } from 'interiores-mapa';

@Injectable()
export class InformesService {

    constructor(
        private authService: AuthenticationService,
        private sws: ServiciosWebServiceProvider,
    private entityManager: EntityManagerProvider,
        private idiomaService: IdiomaService,
        private swsStats: ServiciosStatsProvider,
        private translate: TranslateService,
    ) {


    }

 /* *** SELECTORES  ** */
    // Tipologias
    obtenerTipologias() {
        const that = this;
        const entityManager = that.entityManager;
        const idEspacio = that.authService.getIdEspacio();
        return entityManager.getTipologiasLocalizablesEspacio(idEspacio)
        .then(function (entidades) {
            let tipologiasContenido = [];
            tipologiasContenido = entidades;
            tipologiasContenido.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : ((b.Nombre > a.Nombre) ? -1 : 0));
            // TODO: Filtrar tipologias, coger solo las que son TipoUbicacion = DIRECTA o INDIRECTA
            return tipologiasContenido;
        });
    }
    obtenerSecciones(){
        const that = this;
        const entityManager = that.entityManager;
        const idEspacio = that.authService.getIdEspacio();
        return entityManager.getSECCION()
        .then(function (secciones) {
            let seccioneslist = [];
            seccioneslist = secciones;
            seccioneslist.sort((a, b) => (a.Nombre > b.Nombre) ? 1 : ((b.Nombre > a.Nombre) ? -1 : 0));
            return seccioneslist;
        });
    }
    // Contenidos
    obtenerContenidosByTipologiad(idsTipologias, idiomaSeleccionado?): Promise<Contenido[]> {
        const that = this;
        let contenidosFiltrados = [];

        return this.entityManager.getContenidosByTipologiaId(idsTipologias)
        .then(function (data) {
			contenidosFiltrados = [];
			contenidosFiltrados = [];
            if (!data) {
                return contenidosFiltrados;
            }
			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					contenidosFiltrados.push(contenido);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});

			contenidosFiltrados.forEach(elemento => {
				if (elemento.Imagen === undefined) {
					elemento.Imagen = that.authService.getFotoBlobPorDefecto();
				}
			});

            // Traducimos Contenidos al idioma seleccionado
            if (idiomaSeleccionado !== undefined){
                contenidosFiltrados = that.idiomaService.traducirContenidos(contenidosFiltrados, idiomaSeleccionado);
            }

            const informes: Informe[] = [];
			contenidosFiltrados.forEach((cont: Contenido) => {
				const contenido = new Informe().fromContenido(cont);
				informes.push(contenido);
			});

            return informes;
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerLocalizacionTiempoReal');
            console.error(error);

            const informes: Contenido[] = [];
            return informes;
		});
    }



 /* *** TIPOS INFORME ** */

    // TIEMPO REAL
    // get

	/// Deprecated: al final se esta probando a hacer por consulta a breeze obtenerLocalizacionTiempoReal_3
    obtenerLocalizacionTiempoReal(idsContenidos, TIEMPO_MOSTRAR, idiomaSeleccionado?, listaSecciones?): Promise<Contenido[]>{
		const that = this;
        const token = this.authService.getToken();
        const idEspacio = that.authService.getIdEspacio();

        let contenidosFiltrados = [];
        let includes = '';

        includes = includes + 'IDIOMAS.IDIOMA, ';
        includes = includes + 'SECCIONES.SECCION, ';
        includes = includes + 'NODODS.NODO.SECCION';

        return this.entityManager.getContenidosById(idsContenidos, includes)
        .then(function (data) {
			contenidosFiltrados = [];
            if (!data) {
                return contenidosFiltrados;
            }

			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data = data.sort(function(a, b){
				return idsContenidos.indexOf(a.Id) - idsContenidos.indexOf(b.Id);
			});

			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					contenidosFiltrados.push(contenido);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});

            // Traducimos Contenidos al idioma seleccionado
            if (idiomaSeleccionado !== undefined){
                contenidosFiltrados = that.idiomaService.traducirContenidos(contenidosFiltrados, idiomaSeleccionado);
            }
            return that.swsStats.getLocalizacionTiempoRealContenidos(token, idsContenidos).toPromise();
        })
        .then(function(localizacionTiempoReal){
            contenidosFiltrados.forEach(cont => {
                    let ultimo = localizacionTiempoReal.lista.find(h => h.Contenido_Id === cont.Id);
                    if (ultimo && ultimo.Actual) {
                        const today = new Date();
                        const FechaUbicacionaux = new Date(ultimo.Actual.FechaUbicacion);
                        const FechaUbicacion = new Date(Date.UTC(FechaUbicacionaux.getFullYear() , FechaUbicacionaux.getMonth() , FechaUbicacionaux.getDate() , FechaUbicacionaux.getHours() , FechaUbicacionaux.getMinutes() , FechaUbicacionaux.getSeconds()));

                        const diffMs_FechaUbicacion = (today.getTime() - FechaUbicacion.getTime()); // milliseconds between now & Christmas
                        const diffDays_FechaUbicacion = Math.floor(diffMs_FechaUbicacion / 86400000); // days
                        const diffHrs_FechaUbicacion = Math.floor((diffMs_FechaUbicacion % 86400000) / 3600000); // hours
                        const diffMins_FechaUbicacion = Math.round(((diffMs_FechaUbicacion % 86400000) % 3600000) / 60000); // minutes

                        const aux_min_mostrar = diffMins_FechaUbicacion + diffHrs_FechaUbicacion * 60 + diffDays_FechaUbicacion * 24 * 60;

                        if (TIEMPO_MOSTRAR > 0 && aux_min_mostrar >= TIEMPO_MOSTRAR) {
                            cont.mostrar = false;
                        }
                        else if (TIEMPO_MOSTRAR > 0){
                            cont.mostrar = true;
                        }
                        else if(TIEMPO_MOSTRAR === 0){
                            cont.mostrar = true;
                        }
                        else {
                            cont.mostrar = false;
                        }
                        cont.FechaUltimaLocalizacion = FechaUbicacion;
                        cont.TiempoDesdeUltimaLocalizacion = diffDays_FechaUbicacion + that.translate.instant('Informes.dias') + diffHrs_FechaUbicacion  +  that.translate.instant('Informes.horas') + diffMins_FechaUbicacion + that.translate.instant('Informes.minutos');
                    }
                    else {
                        cont.PermaneceDesde = that.translate.instant('Informes.nuncaLocalizadoLabel'); //  'Nunca ha ha sido Localizado.';
                    }
            });
            let aux = contenidosFiltrados.filter( c => c.mostrar === true);
            if(listaSecciones){
                listaSecciones.forEach(element => {
                    aux = aux.filter(s => s.Seccion === element);
                });
            }

            return aux;
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerLocalizacionTiempoReal');
            console.error(error);

            const informes: Contenido[] = [];
            return informes;
		});
    }

	/// Deprecated: Prueba para intentar optimizar pero va mas lento, al final se esta probando a hacer por consulta a breeze
	obtenerLocalizacionTiempoReal_2(idsContenidos, TIEMPO_MOSTRAR, idiomaSeleccionado?, listaSecciones?): Promise<Contenido[]>{
		const that = this;
        const token = this.authService.getToken();
        let contenidosFiltrados = [];

		return that.swsStats.getLocalizacionTiempoRealContenidos_ext(token, idsContenidos).toPromise()
        .then(function(localizacionTiempoReal){
			localizacionTiempoReal = localizacionTiempoReal.lista;
			contenidosFiltrados = [];
            if (!localizacionTiempoReal) {
                return contenidosFiltrados;
            }

			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			localizacionTiempoReal = localizacionTiempoReal.sort(function(a, b){
				return idsContenidos.indexOf(a.Id) - idsContenidos.indexOf(b.Id);
			});

			localizacionTiempoReal.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					contenidosFiltrados.push(contenido);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});

            // Traducimos Contenidos al idioma seleccionado
            if (idiomaSeleccionado !== undefined){
                contenidosFiltrados = that.idiomaService.traducirContenidos(contenidosFiltrados, idiomaSeleccionado);
            }

            contenidosFiltrados.forEach(cont => {
                    let ultimo = localizacionTiempoReal.find(h => h.Contenido_Id === cont.Id);
                    if (ultimo && ultimo.Actual) {
                        const today = new Date();
                        const FechaUbicacionaux = new Date(ultimo.Actual.FechaUbicacion);
                        const FechaUbicacion = new Date(Date.UTC(FechaUbicacionaux.getFullYear() , FechaUbicacionaux.getMonth() , FechaUbicacionaux.getDate() , FechaUbicacionaux.getHours() , FechaUbicacionaux.getMinutes() , FechaUbicacionaux.getSeconds()));

                        const diffMs_FechaUbicacion = (today.getTime() - FechaUbicacion.getTime()); // milliseconds between now & Christmas
                        const diffDays_FechaUbicacion = Math.floor(diffMs_FechaUbicacion / 86400000); // days
                        const diffHrs_FechaUbicacion = Math.floor((diffMs_FechaUbicacion % 86400000) / 3600000); // hours
                        const diffMins_FechaUbicacion = Math.round(((diffMs_FechaUbicacion % 86400000) % 3600000) / 60000); // minutes

                        const aux_min_mostrar = diffMins_FechaUbicacion + diffHrs_FechaUbicacion * 60 + diffDays_FechaUbicacion * 24 * 60;

                        if (TIEMPO_MOSTRAR > 0 && aux_min_mostrar >= TIEMPO_MOSTRAR) {
                            cont.mostrar = false;
                        }
                        else if (TIEMPO_MOSTRAR > 0){
                            cont.mostrar = true;
                        }
                        else if(TIEMPO_MOSTRAR === 0){
                            cont.mostrar = true;
                        }
                        else {
                            cont.mostrar = false;
                        }
                        cont.FechaUltimaLocalizacion = FechaUbicacion;
                        cont.TiempoDesdeUltimaLocalizacion = diffDays_FechaUbicacion + that.translate.instant('Informes.dias') + diffHrs_FechaUbicacion  +  that.translate.instant('Informes.horas') + diffMins_FechaUbicacion + that.translate.instant('Informes.minutos');
                    }
                    else {
                        cont.PermaneceDesde = that.translate.instant('Informes.nuncaLocalizadoLabel'); //  'Nunca ha ha sido Localizado.';
                    }
            });
            let aux = contenidosFiltrados.filter( c => c.mostrar === true);
            if(listaSecciones){
                listaSecciones.forEach(element => {
                    aux = aux.filter(s => s.Seccion === element);
                });
            }

            return aux;
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerLocalizacionTiempoReal');
            console.error(error);

            const informes: Contenido[] = [];
            return informes;
		});
    }

    obtenerLocalizacionTiempoReal_3(idsContenidos, TIEMPO_MOSTRAR, idiomaSeleccionado?, listaSecciones?, idsTipologia?): Promise<Contenido[]>{
		const that = this;
        const token = this.authService.getToken();
        const idEspacio = that.authService.getIdEspacio();

        let contenidosFiltrados = [];
        let includes = '';

        includes = includes + 'IDIOMAS.IDIOMA, ';
        includes = includes + 'SECCIONES.SECCION, ';
        includes = includes + 'NODODS.NODO.SECCION, ';
		includes = includes + 'TIPOLOGIA_CONTENIDO.IDIOMAS, ';
		includes = includes + 'POSICION_ACTUAL_CONTENIDOS.NODO.SECCION.ALA.NIVEL, ';
		includes = includes + 'POSICION_ULTIMA_CONTENIDOS.NODO.SECCION.ALA.NIVEL';

        return this.entityManager.getContenidosByTipologiaId(idsTipologia, includes)
        .then(function (data) {
			contenidosFiltrados = [];
            if (!data) {
                return contenidosFiltrados;
            }

			const auxi = data.filter( c =>  idsContenidos.indexOf(c.Id) >= 0);
			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data = auxi.sort(function(a, b){
				return idsContenidos.indexOf(a.Id) - idsContenidos.indexOf(b.Id);
			});

			data.forEach(cont => {
				try {
					const contenido = new Contenido().fromENTIDAD(cont);
					if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
						contenido.Imagen = that.authService.getFotoPorDefecto();
					}
					contenidosFiltrados.push(contenido);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});

            // Traducimos Contenidos al idioma seleccionado
            if (idiomaSeleccionado !== undefined){
                contenidosFiltrados = that.idiomaService.traducirContenidos(contenidosFiltrados, idiomaSeleccionado);
            }

            contenidosFiltrados.forEach(cont => {
				let ultimo = contenidosFiltrados.find(h => h.Id === cont.Id);
				if (ultimo && ultimo.Actual) {
					const today = new Date();
					const FechaUbicacionaux = new Date(ultimo.Actual.FechaUbicacion);
					// const FechaUbicacion = new Date(Date.UTC(FechaUbicacionaux.getFullYear() , FechaUbicacionaux.getMonth() , FechaUbicacionaux.getDate() , FechaUbicacionaux.getHours() , FechaUbicacionaux.getMinutes() , FechaUbicacionaux.getSeconds()));
					const FechaUbicacion = FechaUbicacionaux;
					const diffMs_FechaUbicacion = (today.getTime() - FechaUbicacion.getTime()); // milliseconds between now & Christmas
					const diffDays_FechaUbicacion = Math.floor(diffMs_FechaUbicacion / 86400000); // days
					const diffHrs_FechaUbicacion = Math.floor((diffMs_FechaUbicacion % 86400000) / 3600000); // hours
					const diffMins_FechaUbicacion = Math.round(((diffMs_FechaUbicacion % 86400000) % 3600000) / 60000); // minutes

					const aux_min_mostrar = diffMins_FechaUbicacion + diffHrs_FechaUbicacion * 60 + diffDays_FechaUbicacion * 24 * 60;

					if (TIEMPO_MOSTRAR > 0 && aux_min_mostrar >= TIEMPO_MOSTRAR) {
						cont.mostrar = false;
					}
					else if (TIEMPO_MOSTRAR > 0){
						cont.mostrar = true;
					}
					else if(TIEMPO_MOSTRAR === 0){
						cont.mostrar = true;
					}
					else {
						cont.mostrar = false;
					}
					cont.FechaUltimaLocalizacion = FechaUbicacion;
                    if(diffDays_FechaUbicacion < 1 && diffHrs_FechaUbicacion < 1 && diffMins_FechaUbicacion < 3){
                        cont.TiempoDesdeUltimaLocalizacion = 'Ahora';
                    }else{  
                        cont.TiempoDesdeUltimaLocalizacion = diffDays_FechaUbicacion + that.translate.instant('Informes.dias') + diffHrs_FechaUbicacion  +  that.translate.instant('Informes.horas') + diffMins_FechaUbicacion + that.translate.instant('Informes.minutos');
                    }
					
				}
				else {
					cont.PermaneceDesde = that.translate.instant('Informes.nuncaLocalizadoLabel'); //  'Nunca ha ha sido Localizado.';
				}
            });
            let aux = contenidosFiltrados.filter( c => c.mostrar === true);

            if(listaSecciones.length > 0){
                console.log(listaSecciones);
                let auxContenidos = [];
                 listaSecciones.forEach(seccion => {
                    aux.filter(s => s.Seccion === seccion).forEach(element => {
                        auxContenidos.push(element);
                     });
                    console.log(auxContenidos)
                });
                aux = auxContenidos;
                return auxContenidos;
             }else{
                
                return aux;
             }

            
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerLocalizacionTiempoReal');
            console.error(error);

            const informes: Contenido[] = [];
            return informes;
		});
    }

    // HISTORICOS
    // get
    obtenerHistoricoLocalizacionesContenidos(idsContenidos, fechaDesde, fechaHasta, duration, idiomaSeleccionado?, listaSecciones?, listaTipologiasSecciones?): Promise<HistoricoLocalizacionContenido[]>{
		const that = this;
        const token = this.authService.getToken();
        const idEspacio = that.authService.getIdEspacio();

        let historicosFiltrados: HistoricoLocalizacionContenido[]  = [];

        return this.swsStats.getHistoricoLocalizacionesContenidos(token, idsContenidos, fechaDesde, fechaHasta).toPromise()
        .then(function (data) {
            //console.log(data)
			historicosFiltrados = [];
            if (!data) {
                return historicosFiltrados;
            }
			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data.lista = data.lista.sort(function(a, b){
				return idsContenidos.indexOf(a.Contenido_Id) - idsContenidos.indexOf(b.Contenido_Id);
			});

			data.lista.forEach(cont => {
				try {
                	// const historico = new HistoricoLocalizacionContenido(that.entityManager).fromENTIDAD(cont);
                    const historico = new HistoricoLocalizacionContenido().fromENTIDAD(cont);
                    let FechaAux = new Date(historico.FechaDesde);
                    historico.FechaDesde = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(historico.FechaHasta);
                    historico.FechaHasta = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

					historicosFiltrados.push(historico);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});
            return that.rellenarContenidosHistoricos(historicosFiltrados);
        })
        .then(function(historicos){

            if(listaSecciones && listaSecciones.length > 0){
               let  auxHistoricosSecciones = [];
                listaSecciones.forEach(seccion => {
                    historicos.filter(s => s.Seccion === seccion).forEach(element => {
                        auxHistoricosSecciones.push(element);
                    });
               });
               historicos = auxHistoricosSecciones;
            }
            if(listaTipologiasSecciones && listaTipologiasSecciones.length > 0){
                let  auxHistoricosTipologiasSecciones = [];
                listaTipologiasSecciones.forEach(tipoSeccion => {
                    let historicosConSeccion = historicos.filter(h => h.SeccionFormulario);
                    let historicosConTipologiaSeccion = historicosConSeccion.filter(h => h.SeccionFormulario.TIPOLOGIAS_SECCION.length > 0);
                    historicosConTipologiaSeccion.filter(s => s.SeccionFormulario.TIPOLOGIAS_SECCION[0].nombre === tipoSeccion).forEach(element => {
                        auxHistoricosTipologiasSecciones.push(element);
                     });
                });
                historicos = auxHistoricosTipologiasSecciones;
             }

            if(duration > 0){
                let auxTiempoHistorico = [];
                let tiempo = duration*60000;
                historicos.forEach(element => {
                    let tiempoUbicacion = element.FechaHasta.getTime() - element.FechaDesde.getTime();
                    if(tiempoUbicacion >= tiempo){
                        auxTiempoHistorico.push(element);
                    }
                    
                });
                historicos = auxTiempoHistorico;
            }

            

            // Ordenamos los historicos por Elemento, FechaDesde, FechaHasta
			historicos = historicos.sort((a, b) => {

				let desde = 0;
				if (a.FechaDesde > b.FechaDesde) {
					desde =  1;
				} else if (a.FechaDesde < b.FechaDesde) {
					desde =  -1;
				} else {
					desde =  0;
				}

				let hasta = 0;
				if (a.FechaHasta > b.FechaHasta) {
					hasta =  1;
				} else if (a.FechaHasta < b.FechaHasta) {
					hasta =  -1;
				} else {
					hasta =  0;
				}

                return a.Elemento.localeCompare(b.Elemento) || desde || hasta;

			});


            
            return historicos;
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerHistoricoLocalizacionesContenidos');
            console.error(error);

            historicosFiltrados = [];
            return historicosFiltrados;
		});
    }
    // rellenar
    rellenarContenidosHistoricos(historicos: HistoricoLocalizacionContenido[]){
        const that = this;
        let includes = 'IDIOMAS.IDIOMA';
        // includes = includes + 'NODODS.NODO.SECCION,';
		// includes = includes + 'TIPOLOGIA_CONTENIDO, ';
		// includes = includes + 'ALAS, ';
        // includes = includes + 'ALA_PLANO, ';
		// includes = includes + 'IDIOMAS.IDIOMA';
        // includes = includes + 'SECCIONES.SECCION';
        let secciones = [];
        let alas = [];
        const ids = [];
        historicos.forEach(element => {
            const aux = ids.find(cont => cont === element.Contenido_Id);

            if (!aux) {
                ids.push(element.Contenido_Id);
            }

        });


        return that.entityManager.getSECCION(undefined, includes)
		.then(function(resp){
            secciones = resp;
            return that.entityManager.getALA(undefined, includes);
        })
		.then(function(resp){
            alas = resp;
            includes += ', NODODS';
            return that.entityManager.getContenidosById(ids, includes);
        })
		.then(function(contenidos){
            const historicosRellenos: HistoricoLocalizacionContenido[] = [];

            historicos.forEach(element => {
                const contenidoENTIDAD = contenidos.find(cont => cont.Id === element.Contenido_Id);
                const seccionHistorico = secciones.find(sec  => sec.Id === element.Seccion_Id);
                const alaHistorico = alas.find(sec  => sec.Id === element.Ala_Id);


                const contenido = new Contenido().fromENTIDAD(contenidoENTIDAD);

                const historicoAux: HistoricoLocalizacionContenido = element;
                element.rellenarContenido(contenido, seccionHistorico, alaHistorico);

                historicosRellenos.push(historicoAux);
            });

            // Traducimos Contenidos al idioma seleccionado
            // TODO: Crear una funcion para traducir historico segun el id_contenido y que le cambie nombre, descripcion, seccion y tipologia al idioma indicado
            /*if (idiomaSeleccionado !== undefined){
                historicosFiltrados = that.idiomaService.traducirContenidos(historicosFiltrados, idiomaSeleccionado);
            }*/

            return historicosRellenos;

		});
    }

    // COINCIDENCIAS
    // get
    obtenerCoincidenciasLocalizacionContenidos(idsContenidos, fechaDesde, fechaHasta, idiomaSeleccionado?): Promise<CoincidenciasLocalizacionContenidos[]>{
		const that = this;
        const token = this.authService.getToken();
        const idEspacio = that.authService.getIdEspacio();

        let coincidenciasFiltradas: CoincidenciasLocalizacionContenidos[]  = [];


        return this.swsStats.getCoincidenciasLocalizacion(token, idsContenidos, fechaDesde, fechaHasta).toPromise()
        .then(function (data) {
			coincidenciasFiltradas = [];
            if (!data) {
                return coincidenciasFiltradas;
            }
			// Ordenamos los contenidos segun el orsen en el que obtubimos los id ya que el breeze no nos devuelve los contenidos en el orden de los Ids
			data.lista = data.lista.sort(function(a, b){
				return idsContenidos.indexOf(a.Id) - idsContenidos.indexOf(b.Id);
			});

			data.lista.forEach(cont => {
				try {
                    const coincidencia = new CoincidenciasLocalizacionContenidos().fromENTIDAD(cont);

                    let FechaAux = new Date(coincidencia.desde_1);
                    coincidencia.desde_1 = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(coincidencia.hasta_1);
                    coincidencia.hasta_1 = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(coincidencia.desde_2);
                    coincidencia.desde_2 = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(coincidencia.hasta_2);
                    coincidencia.hasta_2 = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(coincidencia.hasta_min);
                    coincidencia.hasta_min = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));

                    FechaAux = new Date(coincidencia.desde_max);
                    coincidencia.desde_max = new Date(Date.UTC(FechaAux.getFullYear() , FechaAux.getMonth() , FechaAux.getDate() , FechaAux.getHours() , FechaAux.getMinutes() , FechaAux.getSeconds()));


					coincidenciasFiltradas.push(coincidencia);
				}
				catch (ex) {
					 console.error('MensajesEmergentes.MENSAJE_ERROR_CONTENIDOS_CARGAR');
				}
			});

            return that.rellenarContenidosCoincidencias(coincidenciasFiltradas);
        })
        .then(function(coincidencias){
            return coincidencias;
        })
        .catch(function (error) {
            // ERROR
            console.error('Error al obtenerCoincidenciasLocalizacionContenidos');
            console.error(error);

            coincidenciasFiltradas = [];
            return coincidenciasFiltradas;
		});
    }
    // rellenar
    rellenarContenidosCoincidencias(coincidenciasFiltradas: CoincidenciasLocalizacionContenidos[]){
        const that = this;
        const includes = 'IDIOMAS.IDIOMA';
        let secciones;
        const ids = [];
        coincidenciasFiltradas.forEach(element => {
            let aux = ids.find(cont => cont === element.contenido_1);
            if (!aux) {
                ids.push(element.contenido_1);
            }
            aux = ids.find(cont => cont === element.contenido_2);
            if (!aux) {
                ids.push(element.contenido_2);
            }
        });

        const listaCoincidencias = coincidenciasFiltradas;
        return that.entityManager.getSECCION(undefined, includes)
		.then(function(resp){
            secciones = resp;
            return that.entityManager.getContenidosById(ids, includes);
        })
		.then(function(contenidos){
            const coincidenciasRellenos: CoincidenciasLocalizacionContenidos[] = [];

            listaCoincidencias.forEach(element => {
                const Contenido_1ENTIDAD = contenidos.find(cont => cont.Id === element.contenido_1);
                const Contenido_2ENTIDAD = contenidos.find(cont => cont.Id === element.contenido_2);
                const seccionCoincidencia = secciones.find(sec  => sec.Id === element.Seccion_Id);

                if (Contenido_1ENTIDAD && Contenido_2ENTIDAD) {
                    const Contenido_1 = new Contenido().fromENTIDAD(Contenido_1ENTIDAD);
                    const Contenido_2 = new Contenido().fromENTIDAD(Contenido_2ENTIDAD);

                    const coincidenciaAux: CoincidenciasLocalizacionContenidos = element;
                    coincidenciaAux.rellenarContenido(Contenido_1, Contenido_2, seccionCoincidencia);

                    coincidenciasRellenos.push(coincidenciaAux);
                }

            });

            return coincidenciasRellenos;
		});
    }

}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/providers/informes/informes.service.ts